import { useSelector } from 'react-redux';
import { BookingTable, InputForm, Navbar } from './components';

const App = () => {
  const flights = useSelector((state) => state);

  return (
    <>
      <Navbar />

      <section>
        <div className="mt-[160px] mx-4 md:mt-[160px] relative">
          <div className="bg-white rounded-md max-w-6xl w-full mx-auto">
            <InputForm />
          </div>
        </div>

        {flights.length > 0 && (
          <div className="table-container">
            <BookingTable />
          </div>
        )}
      </section>
    </>
  );
};

export default App;
